import { Navigate } from 'react-router-dom';
import useAppStore from '../../store/useAppStore.js';

const ProtectedRoute = ({ children, role }) => {
  const { isAuthenticated, role: userRole } = useAppStore();

  // Fallback to localStorage to handle state loss on page refresh
  const token = localStorage.getItem('token');
  const storedUserJson = localStorage.getItem('user');
  
  let effectiveIsAuthenticated = isAuthenticated;
  let effectiveUserRole = userRole;

  if (!effectiveIsAuthenticated && token && storedUserJson) {
    try {
      const user = JSON.parse(storedUserJson);
      effectiveIsAuthenticated = true;
      effectiveUserRole = user.role;
    } catch (e) {
      // Parsing failed or storage corrupted, fall back to store state
    }
  }

  if (!effectiveIsAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (role && effectiveUserRole !== role) {

    // Redirect to appropriate dashboard based on user role
    const roleRedirects = {
      'admin': '/admin',
      'manager': '/branch-manager',
      'staff': '/staff',
      'cashier': '/staff'
    };

    return <Navigate to={roleRedirects[effectiveUserRole] || '/'} replace />;
  }

  return children;
};

export default ProtectedRoute;